import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { FormInstance } from 'antd/es/form';
import produce from 'immer';
import { get } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import styled from 'styled-components/macro';
import InputWrapper from 'components/learning/quiz/components/parts/InputWrapper';
import { TQuizOption, TQuizAnswer, TItemData, TColumnData, TIndexAnswer } from 'modules/learning';
import { isResettingDoneState } from 'modules/learning/recoilState';
import { Button } from 'antd';
import { PrimaryColor, PlusOutlineIcon, MinusOutlineIcon } from 'GlobalStyles';

const IndexTypeAnswer = ({
  form,
  options,
  setOptions,
  userAnswer,
  setUserAnswer,
  defaultAnswer,
  setDefaultAnswer,
}: {
  form: FormInstance;
  options?: Array<TQuizOption>;
  setOptions?: (x: any) => void;
  userAnswer?: Array<TQuizOption>;
  setUserAnswer?: (x: any) => void;
  defaultAnswer?: Array<TQuizAnswer>;
  setDefaultAnswer?: (x: any) => void;
}) => {
  const { operation, id }: { operation: string; id: string } = useParams();
  const [indexAnswerState, setIndexAnswerState] = useState<TIndexAnswer>({
    columns: [],
  });
  const quizState = useSelector((store: RootState) => store.createQuizReducer);
  const [isResettingDone, setIsResettingDone] = useRecoilState(isResettingDoneState);

  const deleteItem = (col: number, depth: number) => {
    const nextState = produce(indexAnswerState, (draft) => {
      const column = draft?.columns.find((column) => column.column_index === col);
      if (column) {
        const index = column.items.findIndex((item) => item.depth === depth);
        column.items.splice(index, 1);
      }
    });
    setIndexAnswerState(nextState);
  };

  const deleteColumn = (col: number) => {
    const nextState = produce(indexAnswerState, (draft) => {
      const index = draft?.columns.findIndex((colum) => colum.column_index === col);
      if (index || index === 0) {
        draft?.columns.splice(index, 1);
      }
    });
    setIndexAnswerState(nextState);
  };

  const addItem = (col: number) => {
    const nextState = produce(indexAnswerState, (draft) => {
      const column = draft?.columns.find((column) => column.column_index === col);
      if (column) {
        const addedItem = {
          column_index: col,
          depth: column.items.length + 1,
          content: ``,
          is_shown: false,
          content_number: undefined,
        };
        column.items.push(addedItem);
      }
    });
    setIndexAnswerState(nextState);
  };

  const addColumn = () => {
    const nextState = produce(indexAnswerState, (draft) => {
      const addedStateIndex = indexAnswerState?.columns.length;
      if (addedStateIndex || addedStateIndex === 0) {
        const addedColumn = {
          column_index: addedStateIndex,
          depth: 0,
          content: ``,
          is_shown: false,
          content_number: undefined,
          items: [],
        };
        draft?.columns.push(addedColumn);
      }
    });

    setIndexAnswerState(nextState);
  };

  //get으로 받은 데이터를 colums, items의 데이터 구조로 조작

  //indexAnswerState 값 바뀔때마다 index, depth 다시 설정
  //문제 등록할 때 중간의 행이나 열을 삭제하거나 추가하면 행/열 값을 다시 설정해주어야하므로
  useEffect(() => {
    if (indexAnswerState?.columns) {
      const resettingColumnIndexDepth = produce(indexAnswerState, (draft) => {
        for (let i = 0; i < indexAnswerState?.columns.length; i++) {
          //immer 활용해서 각각 columns[i] 에 접근
          const column = draft.columns[i];
          column.column_index = i;
          for (let x = 0; x < column.items.length; x++) {
            const item = column.items[x];
            item.column_index = i;
            item.depth = x + 1;
          }
        }
      });
      setIndexAnswerState(resettingColumnIndexDepth);
      setIsResettingDone(true);
    }
  }, [indexAnswerState]);
  const formmatingGetIndexAnswer = (getAnswer: Array<TQuizAnswer>) => {
    const newAnswerStateObj: { columns: any } = {
      columns: [],
    };
    //가장 윗 행 세팅 (depth가 0인 요소들)
    const mainRow: any = getAnswer
      .filter((el: TQuizAnswer) => el.depth === 0)
      .map((mainRowElement: TQuizAnswer) => {
        return { ...mainRowElement, items: [] };
      });

    // column_index기준으로 오름차순
    const columnAscendingSort = mainRow.sort(function(a: TColumnData, b: TColumnData) {
      if (a.column_index !== null && b.column_index !== null) return a.column_index - b.column_index;
    });
    newAnswerStateObj.columns = columnAscendingSort;

    if (newAnswerStateObj.columns.length >= 1) {
      for (let i = 0; i < newAnswerStateObj.columns.length; i++) {
        const columnIndexNum = newAnswerStateObj.columns[i].column_index;
        const depthNum = newAnswerStateObj.columns[i].depth;
        const filterItem: any = getAnswer.filter(
          (el: TQuizAnswer) => el.column_index === columnIndexNum && el.depth !== depthNum,
        );
        // items는 depth기준으로 오름차순
        const itemAscendingSort = filterItem.sort(function(a: TItemData, b: TItemData) {
          return a.depth - b.depth;
        });
        newAnswerStateObj.columns[i].items = itemAscendingSort;
      }
    }
    return newAnswerStateObj;
  };

  useEffect(() => {
    if (!!id && Number(id) === quizState.id) {
      const formmatedIndexAnswer = formmatingGetIndexAnswer(quizState.quiz_answer);
      setIndexAnswerState(formmatedIndexAnswer);
    }
  }, [quizState.quiz_answer]);

  return (
    <>
      {operation !== 'view' && (
        <StyledAnswerWrapper>
          <StyledColumnWrapper>
            {get(indexAnswerState, 'columns')?.map((column: TColumnData, idx) => {
              return (
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <StyledColumnAndItems key={idx} style={{ width: '260px' }}>
                      {/* column main 한 줄/ */}
                      <InputWrapper
                        col={column.column_index}
                        depth={0}
                        indexAnswerState={indexAnswerState as TIndexAnswer}
                        setIndexAnswerState={setIndexAnswerState}
                        form={form}
                        answer_id={column.id}
                      />
                      {column.items.map((item: TItemData) => {
                        return (
                          // 아이템 한 줄
                          <StyledItem>
                            <InputWrapper
                              col={column.column_index}
                              depth={item.depth}
                              indexAnswerState={indexAnswerState as TIndexAnswer}
                              setIndexAnswerState={setIndexAnswerState}
                              form={form}
                              answer_id={item.id}
                            />
                            {/* ⭐️ 아이템 삭제 */}
                            <Button
                              className='list-minus-button'
                              onClick={() => {
                                deleteItem(column.column_index, item.depth);
                              }}
                            >
                              <MinusOutlineIcon fill={PrimaryColor} />
                            </Button>
                          </StyledItem>
                        );
                      })}
                    </StyledColumnAndItems>
                    {/* ⭐️ 아이템 추가*/}
                    <Button className='list-plus-button' onClick={() => addItem(column.column_index)}>
                      <PlusOutlineIcon fill={PrimaryColor} />
                    </Button>
                  </div>
                  {/* ⭐️ colum 삭제 */}
                  <Button
                    className='list-minus-button'
                    onClick={() => {
                      deleteColumn(column.column_index);
                    }}
                  >
                    <MinusOutlineIcon fill={PrimaryColor} />
                  </Button>
                </div>
              );
            })}
          </StyledColumnWrapper>
          {/* ⭐️ colum 추가 */}
          <Button className='list-plus-button' onClick={addColumn}>
            <PlusOutlineIcon fill={PrimaryColor} />
          </Button>
        </StyledAnswerWrapper>
      )}
      {operation === 'view' && (
        <StyledAnswerWrapper>
          <StyledColumnWrapper>
            {get(indexAnswerState, 'columns')?.map((column: TColumnData, idx) => {
              return (
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <StyledColumnAndItems
                      key={idx}
                      style={{ width: '260px', margin: '0 20px' }} //최상위값 depth = 0들의 width
                    >
                      {/* column main 한 줄/ */}
                      <InputWrapper
                        col={column.column_index}
                        depth={0}
                        indexAnswerState={indexAnswerState as TIndexAnswer}
                        setIndexAnswerState={setIndexAnswerState}
                        form={form}
                        isShown={column.is_shown}
                        options={options}
                        setOptions={setOptions}
                        userAnswer={userAnswer}
                        setUserAnswer={setUserAnswer}
                        defaultAnswer={defaultAnswer}
                        setDefaultAnswer={setDefaultAnswer}
                      />
                      {column.items.map((item: TItemData) => {
                        return (
                          // 아이템 한 줄
                          //하위 아이템들의 depth >= 1들의 width
                          <StyledItem style={{ width: '230px', margin: '10px 10px 0' }}>
                            <InputWrapper
                              col={column.column_index}
                              depth={item.depth}
                              indexAnswerState={indexAnswerState as TIndexAnswer}
                              setIndexAnswerState={setIndexAnswerState}
                              form={form}
                              isShown={item.is_shown}
                              options={options}
                              setOptions={setOptions}
                              userAnswer={userAnswer}
                              setUserAnswer={setUserAnswer}
                              defaultAnswer={defaultAnswer}
                              setDefaultAnswer={setDefaultAnswer}
                            />
                          </StyledItem>
                        );
                      })}
                    </StyledColumnAndItems>
                  </div>
                </div>
              );
            })}
          </StyledColumnWrapper>
        </StyledAnswerWrapper>
      )}
    </>
  );
};

export default IndexTypeAnswer;

const StyledAnswerWrapper = styled.div`
  display: flex;
`;

//colum(하위 아이템들을 포함한 ) wrapper
const StyledColumnWrapper = styled.div`
  display: flex;
`;

const StyledColumnAndItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledItem = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 10px;
`;
